import { Directive, effect, ElementRef, inject, input } from '@angular/core';

@Directive({
  selector: '[appTotalSize]'
})
export class TotalSizeDirective {
  readonly #elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  public readonly text = input('', { alias: 'appTotalSize' });

  public constructor() {
    effect(() => {
      const value = this.text() ?? '';
      const length = value.length;
      this.#elementRef.nativeElement.innerText = value;

      let fontSize = 20;
      if (length >= 20) {
        fontSize = 12;
      }
      if (length > 10 && length < 20) {
        fontSize = 28 - Math.floor(length * 0.8);
      }

      this.#elementRef.nativeElement.style.fontSize = `${fontSize}px`;
    });
  }
}
